// Generated by purs version 0.15.15
import * as Control_Semigroupoid from "../Control.Semigroupoid/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Restaumatic_Form_Widgets from "../Restaumatic.Form.Widgets/index.js";
import * as Restaumatic_Prelude from "../Restaumatic.Prelude/index.js";
import * as Restaumatic_Prelude_Specular from "../Restaumatic.Prelude.Specular/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var compose2 = /* #__PURE__ */ Restaumatic_Prelude.compose2(Control_Semigroupoid.semigroupoidFn);
var Modifier = function (x) {
    return x;
};
var unwrapModifier = function (v) {
    return v;
};
var fieldId = function (dictHasFieldId) {
    var $9 = Restaumatic_Form_Widgets.fieldId(dictHasFieldId);
    return function ($10) {
        return Modifier($9($10));
    };
};
var element = function () {
    return function (tag) {
        return function (defaultProps) {
            return function (props) {
                return function (body) {
                    return Specular_Dom_Element.el(tag)(append(defaultProps)(map(unwrapModifier)(props)))(body);
                };
            };
        };
    };
};
var element1 = /* #__PURE__ */ element();
var emptyElement = function () {
    return function (tag) {
        return function (defaultProps) {
            return function (props) {
                return element1(tag)(defaultProps)(props)(Restaumatic_Prelude_Specular.wempty);
            };
        };
    };
};
var classesModifierD = function ($11) {
    return Modifier(Specular_Dom_Element.classesD($11));
};
var classesModifier = function ($12) {
    return Modifier(Specular_Dom_Element.classes($12));
};
var classModifier = function ($13) {
    return Modifier(Specular_Dom_Element.class_($13));
};
var attrsModifier = function ($14) {
    return Modifier(Specular_Dom_Element.attrs($14));
};
var attrModifierD = /* #__PURE__ */ compose2(Modifier)(Specular_Dom_Element.attrD);
var attrModifier = /* #__PURE__ */ compose2(Modifier)(Specular_Dom_Element.attr);
var id = /* #__PURE__ */ attrModifier("id");
export {
    Modifier,
    unwrapModifier,
    classModifier,
    attrsModifier,
    attrModifier,
    attrModifierD,
    classesModifier,
    classesModifierD,
    element,
    emptyElement,
    id,
    fieldId
};
